<template>
  <div class="entity container">
    <h3 class="ui header" v-if="visibleFields.hosts">Hosts</h3>
    <sui-segment emphasis="secondary" v-if="visibleFields.hosts">
      <ContainerHosts v-model="entity.hosts" fieldName="hosts" ref="hosts" />
    </sui-segment>
  </div>
</template>

<script>
  import ContainerHosts from '@/components/forms/ContainerHosts'
  import FormEntity from '@/mixins/FormEntity'

  export default {
    name: 'FormContainer',
    mixins: [
      FormEntity,
    ],
    components: {
      ContainerHosts,
    },
    data() {
      return {
        object: 'Container',
      }
    },
  }
</script>
